import { TileHexType } from '@colonist/game-states';
export class MechanicValidatorPirate {
    seaTilesWithoutPirate() {
        const pirateArray = [];
        for (const [index, tile] of this.mapValidator.tileState.tiles.entries()){
            if (index == this.pirateState.locationTileIndex) continue;
            if (tile.tileType != TileHexType.Sea) continue;
            pirateArray.push(index);
        }
        return pirateArray;
    }
    whereCanPlayerPlacePirate(playersProtectedByFriendlyRobber) {
        const seaTilesWithoutRobber = this.seaTilesWithoutPirate();
        const tilesToHighlight = [];
        for (const tile of seaTilesWithoutRobber){
            if (this.mapValidator.arePlayersProtectedByFriendlyRobberTouchingTile(playersProtectedByFriendlyRobber, tile)) continue;
            if (this.mapValidator.doPlayersProtectedByFriendlyRobberHaveShipTouchingTile(playersProtectedByFriendlyRobber, tile)) continue;
            tilesToHighlight.push(tile);
        }
        if (tilesToHighlight.length == 0) tilesToHighlight.push(this.pirateState.locationTileIndex);
        return tilesToHighlight;
    }
    isEdgeTouchingTileWithPirate(tileEdge) {
        for (const touchingHexFaces of tileEdge.hexEdge.touchingFaces()){
            const tileIndex = this.mapValidator.tileState.getTileHexIndex(touchingHexFaces);
            if (tileIndex == undefined) continue;
            if (tileIndex == this.pirateState.locationTileIndex) return true;
        }
        return false;
    }
    constructor(mapValidator, pirateState){
        this.mapValidator = mapValidator;
        this.pirateState = pirateState;
    }
}
